/* Shared report helpers for both assessments */

function fortifyEscapeHtml(str=''){
  return String(str)
    .replaceAll('&','&amp;')
    .replaceAll('<','&lt;')
    .replaceAll('>','&gt;')
    .replaceAll('"','&quot;')
    .replaceAll("'",'&#039;');
}

function openBrandedReportWindow({title, subtitle, summaryHtml, realmRowsHtml, extraHtml, footerText}){
  const win = window.open('', 'FortifyReport', 'width=960,height=800,scrollbars=yes');
  if(!win){ alert('Popup blocked. Please allow popups to view/print the report.'); return null; }

  const cssHref = '../css/fortify.css';

  win.document.write(`<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>${fortifyEscapeHtml(title)} – Report</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
<link rel="stylesheet" href="${cssHref}">
<style>
  .reportCover{padding:28px 22px;border-bottom:1px solid var(--line)}
  .reportCover__k{letter-spacing:.35em;text-transform:uppercase;font-size:12px;color:var(--muted)}
  .reportCover__t{margin:10px 0 6px;font-size:30px;line-height:1.12}
  .reportCover__s{margin:0;color:var(--muted)}
  .reportActions{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px}
</style>
</head>
<body class="bg">
  <main class="doc">
    <section class="doc__panel">
      <div class="reportCover">
        <div class="reportCover__k">THE SOVEREIGNTY PATH</div>
        <h1 class="reportCover__t">${fortifyEscapeHtml(title)}</h1>
        <p class="reportCover__s">${fortifyEscapeHtml(subtitle||'')}</p>
        <div class="reportActions actions">
          <button class="btn" onclick="window.print()">Download / Print PDF</button>
          <button class="btn secondary" onclick="window.close()">Close</button>
        </div>
      </div>

      <div class="doc__body">
        ${summaryHtml || ''}

        ${realmRowsHtml ? `
        <div class="hr"></div>
        <h2 class="h2">Realm Breakdown</h2>
        <table class="table" aria-label="Realm breakdown">
          <thead>
            <tr>
              <th>Realm</th>
              <th>Score</th>
              <th>Percent</th>
              <th>Shadow → Gift → Siddhi (path)</th>
            </tr>
          </thead>
          <tbody>
            ${realmRowsHtml || ''}
          </tbody>
        </table>
        ` : ''}

        ${extraHtml || ''}

        <div class="hr"></div>
        <div class="small" style="letter-spacing:.12em;text-transform:uppercase;">${fortifyEscapeHtml(footerText || 'DeanHobson.com | The Sovereignty Path')}</div>
      </div>
    </section>
  </main>
</body>
</html>`);

  win.document.close();
  return win;
}